import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { Box, Button } from '@otcmarketsgroup/otcm-ui-lib';
import { FaAngleLeft } from "react-icons/fa6";

const BackButton = ({ className, to }) => {
    const navigate = useNavigate();

    const goBack = () => {
        to ? navigate(to) : navigate(-1);
    };

    return <Box pb={2}>
        <Button startIcon={<FaAngleLeft />} variant='text' onClick={goBack}>
            Back to Blue Sky Monitoring
        </Button>
    </Box>;
};

BackButton.propTypes = {
    className: PropTypes.string,
    to: PropTypes.string
};

export default BackButton;
